export class NotificationConfig {
	/**@type {boolean} */
	isSendEmail = false;

	/**@type {boolean} */
	isSendSms = false;
}
